import { fg } from '@atlaskit/platform-feature-flags';

export const getTargetAccountIdSuffix = (targetAccountId: string | null | undefined) => {
	if (fg('jsm_admin_access_user_notification_settings')) {
		return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
	}
	return '';
};
